import validate from "/var/www/html/node_modules/nuxt/dist/pages/runtime/validate.js";
import locale_45global from "/var/www/html/middleware/locale.global.js";
import manifest_45route_45rule from "/var/www/html/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  locale_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}